<!-- <dx-load-panel [visible]="(loading$ | async) || false" shadingColor="rgba(0,0,0,0.4)" [showIndicator]="true"
  [showPane]="true" [shading]="true">
</dx-load-panel> -->

<dx-load-panel class="global-loader white-blue-loader" [visible]="(loading$ | async) || false"
  shadingColor="rgba(0,0,0,0.4)" [showIndicator]="true" [showPane]="true" [shading]="true">
</dx-load-panel>

<ng-container *ngIf="!isAuthPage(); else unauthenticated">
  <app-side-nav-inner-toolbar title="{{appInfo.title}}">
    <router-outlet></router-outlet>
  </app-side-nav-inner-toolbar>
</ng-container>

<ng-template #unauthenticated>
  <app-unauthenticated-content></app-unauthenticated-content>
</ng-template>